import React, { Component } from "react";
// import ReactDOM from 'react-dom';
import logo from "../data/images/Loading-Img.gif";
import green_tick from "../data/images/green_check_1.png";
import red_cross from "../data/images/red_cross_1.png";
import Modal from "./modal.js";
import {store} from "../../index"

import "./index.css";
import { insertTopic, deleteTopic } from "./../data/data";

class menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // topics:this.props.data.list
      AddNewTopic_input: false,
      NewTopicValue: "",
      NewTopicValue_avail: false,
      NewTopicWaitFeedback: false,
      MenuBarMsg: "Hmmm",
      topicDeleteConfirm: false,
      currentDelete: "none",
      menu_toggle : false,
    };
    store.subscribe(() => {
      // When state will be updated(in our case, when items will be fetched), 
      // we will update local component state and force component to rerender 
      // with new data.

      this.setState({
        menu_toggle: store.getState().menu_vis
      });
    });
  }

  // componentDidUpdate(prevProps, prevState, snapshot) {
  //     if (this.state.open_topic_name !== prevState.open_topic_name ){
  //         this.setState({isSiteLoading:true});
  //         Notebook_data(this.state.open_topic_name).then(data => {
  //         this.setState({open_topic:data});
  //         this.setState({isSiteLoading:false});
  //         // console.log("Notbook_data from update",data);
  //       });
  //     };
  // };
  handleindexChange = (index) => {
    this.props.data.update_topic(index);
    // console.log("indexgiven",index);
  };
  //////////////////////////////////////////////////////////////////////////////////////////////
  addNewTopic_input = () => {
    this.setState({ AddNewTopic_input: true });
    console.log("new button add req");
  };
  checkAvail_of_newtopic = (value) => {
    this.setState({ NewTopicValue: value });
    let x;
    for (x in this.props.data.state.topics) {
      if (this.props.data.state.topics[x][1] === value || value === "") {
        this.setState({ NewTopicValue_avail: false });
        break;
      } else {
        this.setState({ NewTopicValue_avail: true });
      }
    }
  };

  newTopic_cancel = () => {
    this.setState({ NewTopicValue: "" });
    this.setState({ NewTopicValue_avail: false });
    this.setState({ AddNewTopic_input: false });
    this.setState({ NewTopicWaitFeedback: false });
  };

  newTopic_submit = async () => {
    this.setState({ NewTopicWaitFeedback: true });
    // console.log(this.state.NewTopicValue, "To be sent for add topic");
    const get_res = async () => {
      const res = await insertTopic(
        this.state.NewTopicValue,
        this.props.data.state.auth_token,
        this.props.data.state.user
      );
      // console.log("response here",res);
      res.data === "Success"
        ? this.props.data.update_topic_list(this.state.NewTopicValue)
        : console.log("Topic Failed");
    };
    this.state.NewTopicValue_avail
      ? await get_res()
      : console.log("Topic Already exist");
    this.newTopic_cancel();
  };
  deleteMenuTopic = async () => {
    let topic = this.state.currentDelete;
    console.log(topic[1], " topic sent for delete Final Operation.");
    this.setState({ topicDeleteConfirm: false });
    await deleteTopic(
      topic,
      this.props.data.state.auth_token,
      this.props.data.state.user
    );
    this.setState({ currentDelete: "none" });
    this.props.data.update_topic_list(null);
  };
  openModal = (topic) => {
    console.log(topic, " wants to get deleted.");
    this.setState({ topicDeleteConfirm: true });
    this.setState({ currentDelete: topic });
  };
  closeOpenModal = () => {
    console.log("modal closed");
    this.setState({ topicDeleteConfirm: false });
    this.setState({ currentDelete: "none" });
  };
  /////////////////////////////////////////////////////////////////////
  render() {
    console.log(" MENU_INDEX >> Render",this.state.menu_toggle);

    // let topics = this.state.topics;
    console.log("6516", this.props.data);
    return (
      <nav id="sidebar" style={{"display":this.state.menu_toggle ? "block" : "none"}}>
        <div id="menu_topic">
          <b>Topic-Menu</b>
        </div>
        <div id="add_topic_wrapper">
          {this.state.AddNewTopic_input ? (
            <div id="add_topic_main">
              <div style={{ display: "block" }}>
                <input
                  title={
                    this.state.NewTopicValue_avail
                      ? "Available"
                      : "Not Available"
                  }
                  type="text"
                  placeholder="Enter New Topic"
                  value={this.state.NewTopicValue}
                  onChange={(e) => this.checkAvail_of_newtopic(e.target.value)}
                />
                {this.state.NewTopicValue_avail ? (
                  <div style={{ display: "inline" }}>
                    <img
                      className="loading-img-micro "
                      alt="new-topic-available"
                      src={green_tick}
                    />
                  </div>
                ) : (
                  <div style={{ display: "inline" }}>
                    <img
                      className="loading-img-micro "
                      alt="topic-not-available"
                      src={red_cross}
                    />
                  </div>
                )}
                {this.state.NewTopicWaitFeedback ? (
                  <div style={{ display: "inline" }}>
                    <img
                      className="loading-img-micro "
                      alt="topic-wait"
                      src={logo}
                    />
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <button type="button" class="btn-sm btn-outline-danger" onClick={() => this.newTopic_cancel()}>
                Cancel
              </button>
              <button type="button" class="btn-sm btn-outline-success" onClick={() => this.newTopic_submit()}>
                Create New
              </button>
            </div>
          ) : (
            <button
              onClick={this.addNewTopic_input.bind(this)}
              style={{
                backgroundColor: "black",
                color: "white",
                float: "right",
                width: "auto",
                height: "auto",
              }}
            >
              New_Topic
            </button>
          )}
        </div>
        <div id="topicList">
          <ul>
            {this.props.data.state.topics ? (
              this.props.data.state.topics.map((d, i) => (
                <li className="closed">
                  <div className="li-container">
                    <button
                      className="topicNameButton"
                      onClick={this.handleindexChange.bind(this, i)}
                    >
                      {i + ". " + d[1]}{" "}
                    </button>
                    <span onClick={this.openModal.bind(this, d)}>
                      <i className="material-icons">delete</i>
                    </span>
                  </div>
                  {/* <button
                  className="deleteTopicButton"
                  onClick={this.openModal.bind(this, d)}
                  >
                  <i className="material-icons">delete</i>
                </button> */}
                </li>
              ))
            ) : (
              <li>No Topics Found </li>
            )}
          </ul>
        </div>
        {/* <div id="menuRow" className="row">
          <div id="menuButton" className="btn-group scroll">
            {this.props.data.state.topics ? (
                this.props.data.state.topics.map((d, i) => (
                    <div key={d + " Menu Button " + i}>
                    <button
                    className="deleteTopicButton"
                    onClick={this.openModal.bind(this, d)}
                    >
                    <i className="material-icons">delete</i>
                    </button>
                    <button
                    className="topicNameButton"
                    onClick={this.handleindexChange.bind(this, i)}
                    >
                    {i + ". " + d[1]}{" "}
                    </button>
                    </div>
                    ))
                    ) : (
                        <div>No Topics Found </div>
                        )}
                        </div>
                    </div> */}
        <Modal
          show={this.state.topicDeleteConfirm}
          handleClose={this.closeOpenModal}
          handleConfirm={this.deleteMenuTopic.bind(this)}
        >
          <div style={{ display: "flex", flexDirection: "row" }}>
            <h4>Do you Want To Delete <b style={{ color: "grey" }}>{this.state.currentDelete[1]}</b> Topic ?</h4>
          </div>
        </Modal>
      </nav>
    );
  }
}
export default menu;
